import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { TrackingProperties } from '@change-corgi/tracking-properties';

export async function trackLandingPageView(slug: string, track: TrackingFn): Promise<boolean> {
	const eventName = `landing_${slug}_view`;
	const eventOptions: TrackingProperties = { issue_category: slug };
	return track(eventName, eventOptions);
}

export async function trackLandingPageCtaClick(slug: string, track: TrackingFn): Promise<boolean> {
	const eventName = `landing_${slug}_cta_click`;
	const eventOptions: TrackingProperties = { issue_category: slug };
	return track(eventName, eventOptions);
}
